// internal
import { validate } from '../validation';
var integer = function integer(min, max) {
  var actualMin = max === undefined ? 0 : min;
  var actualMax = max === undefined ? min : max;
  validate.integerType(actualMin);
  validate.integerType(actualMax);
  validate.maxGreaterThanMin(actualMin, actualMax);
  var randomFloat = Math.random() * (actualMax - actualMin) + actualMin;
  return Math.floor(randomFloat);
};
export { integer };